import {
  ApprovalChainApproverTemplateType,
  ApprovalChainStepTemplateType,
  ApprovalChainTemplateType,
} from '@approvals/graphql';
import { getRandomKey } from './approvals-service';

export function getKey(
  obj:
    | ApprovalChainStepTemplateType
    | ApprovalChainApproverTemplateType
    | ApprovalChainTemplateType
) {
  return obj.id || obj.randomKey || '';
}

export function generateEmptyStep() {
  const randomKey = getRandomKey();
  return {
    randomKey,
    approvalChainApproverTemplates: [],
  };
}

export function generateEmptyApprovalChain() {
  const randomKey = getRandomKey();
  return {
    randomKey,
    approvalChainStepTemplates: [generateEmptyStep()],
  };
}

export function removeItem(
  steps:
    | ApprovalChainStepTemplateType[]
    | ApprovalChainApproverTemplateType[]
    | ApprovalChainTemplateType[],
  index: number
) {
  if (steps[index].id) {
    steps[index].destroy = true;
  } else {
    steps.splice(index, 1);
  }
}
